
import CoachSupportPage from './CoachSupportPage'

export default CoachSupportPage